/**
 * @format
 * @module lib/financial/markets
 */
import format from "date-fns/format";
import ee from "lib/eventemitter";
import isNil from "lodash/isNil";
import ScrollMenuPrototype from "ui/scroll-menu";
import logger from "utils/logger";
import { humanTime } from "utils/time-since";
import { qsa } from "utils/utils";

const debugTag = "[MARKETS]";
const urlVars = new URLSearchParams(document.location.search);
const debugTimes = !isNil(urlVars.get("debugMT")); // extra debug info

export default function init() {
  const features = qsa(".js-c-market-ticker");
  features.forEach(initHorizontalScrollMenu);
}

/**
 * @method initHorizontalScrollMenu
 * @description initializes market ticker component with button click tracking
 * @param {HTMLElement} marketTicker - to be initialized
 */
function initHorizontalScrollMenu(marketTicker) {
  if (isNil(marketTicker)) {
    return;
  }
  logger.info(`${debugTag} init`, marketTicker);

  const scrollMenu = Object.create(ScrollMenuPrototype);
  if (scrollMenu) {
    scrollMenu.init(marketTicker.querySelector(".js-c-market-ticker__scroll-menu"));
  }

  const btnLeft = marketTicker.querySelector(".js-c-market-ticker__arrow-left");
  if (btnLeft) {
    btnLeft.addEventListener("click", onScroll.bind(this, true));
  }

  const btnRight = marketTicker.querySelector(".js-c-market-ticker__arrow-right");
  if (btnRight) {
    btnRight.addEventListener("click", onScroll.bind(this, false));
  }

  // To help debug how old the market ticker data is.
  if (!debugTimes) {
    return;
  }

  const now = parseInt(format(new Date(), "x"), 10);
  const render = new Date(marketTicker.dataset.stamp);
  logger.info(`${debugTag} page render: ${humanTime(render, now)}`);

  const cards = qsa(".js-market-ticker-card", marketTicker);
  const times = cards.map(card => {
    // The exchange timestamp for the last traded price.
    const trade = new Date(card.dataset.tradeStamp);

    return {
      ticker: card.dataset.ticker,
      stamp: card.dataset.tradeStamp,
      age: humanTime(trade, now)
    };
  });

  logger.table(times);
}

/**
 * @method onScroll
 * @description when scroll is clicked, sends a GTM event
 * @param {Boolean} left - true if direction is left; false if direction is right.
 */
function onScroll(left) {
  ee.trigger("analytics.trackGTMEvent", [
    {
      feature: "financial-market-ticker",
      type: "button",
      action: left ? "left" : "right",
      label: "scroll menu"
    },
    "clickEvent"
  ]);
}
